import { Button, message, Popconfirm, Spin } from "antd";
import { useState, useRef } from "react";
import { serverFetch } from "../../server";

const ServiceMain = () => {
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);

  const onRecalcAbon = () => {
    setLoading(true);
    serverFetch("system/RecalcStatusAllAbons", { method: "POST" })
      .then(() => {
        message.success("Успешно завершено");
        setLoading(false);
      })
      .catch(e => {
        message.error(e.userMessage);
        setLoading(false);
      });
  }

  const onRecalcStore = () => {
    setLoading(true);
    serverFetch("store/RecalcRest", { method: "POST" })
      .then(() => {
        message.success("Успешно завершено");
        setLoading(false);
      })
      .catch(e => {
        message.error(e.userMessage);
        setLoading(false);
      });
  }

  const onFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.type === "application/json" || file.name.endsWith('.json')) {
        setSelectedFile(file);
      } else {
        message.error("Пожалуйста, выберите JSON файл");
        event.target.value = null;
      }
    }
  }

  const onImportData = () => {
    if (!selectedFile) {
      message.error("Пожалуйста, выберите файл");
      return;
    }

    setLoading(true);
    const reader = new FileReader();
    
    reader.onload = (e) => {
      try {
        const importData = JSON.parse(e.target.result);
        serverFetch("extranet/import", { method: "POST", bodyData: importData })
          .then(() => {
            message.success("Данные успешно импортированы");
            setLoading(false);
            setSelectedFile(null);
            if (fileInputRef.current) {
              fileInputRef.current.value = null;
            }
          })
          .catch(err => {
            message.error(err.userMessage || "Ошибка импорта данных");
            setLoading(false);
          });
      } catch (error) {
        message.error("Ошибка чтения JSON файла");
        setLoading(false);
      }
    };

    reader.onerror = () => {
      message.error("Ошибка чтения файла");
      setLoading(false);
    };

    reader.readAsText(selectedFile);
  }

  return (
    <div className="col-one-main">
      <div className="col-one-title">Сервисные функции</div>
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        <Popconfirm title="Подтверждение" description="Пересчитать абонементы?" onConfirm={onRecalcAbon}>
          <Button disabled={loading}>Пересчет статусов абонементов</Button>
        </Popconfirm>
        <Popconfirm title="Подтверждение" description="Пересчитать остатки на складе?" onConfirm={onRecalcStore}>
          <Button disabled={loading}>Пересчет остатков на складе</Button>
        </Popconfirm>
      </div>
      <div style={{ marginTop: 20, display: "flex", flexDirection: "column", gap: 10, maxWidth: 400 }}>
        <div className="col-one-title" id="tour-item-service-import-data">Импорт данных</div>
        <input 
          ref={fileInputRef}
          type="file" 
          accept=".json,application/json"
          onChange={onFileChange}
          disabled={loading}
          style={{ padding: "5px" }}
        />
        {selectedFile && (
          <div style={{ fontSize: 12, color: "#666" }}>
            Выбран файл: {selectedFile.name}
          </div>
        )}
        <Popconfirm 
          title="Подтверждение" 
          description="Импортировать данные из выбранного файла?" 
          onConfirm={onImportData}
          disabled={!selectedFile || loading}
        >
          <Button disabled={!selectedFile || loading}>Загрузить</Button>
        </Popconfirm>
      </div>
      {loading && <Spin />}
    </div>
  );
}

export default ServiceMain;

